import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const rewardSupplierAdd = createAsyncThunk("rewardSupplierAdd", async (values, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`channel/${values.channel}/supplier`, { ...values, channel: undefined });

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardSupplierAddSlice = createSlice({
	name: "RewardSupplierAddSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetRewardSupplierAddState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(rewardSupplierAdd.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(rewardSupplierAdd.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(rewardSupplierAdd.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetRewardSupplierAddState } = RewardSupplierAddSlice.actions;

export default RewardSupplierAddSlice.reducer;
